import _ from 'underscore';
import { CustomParametersView } from '@bingads-webui-campaign/upgrade-url';

/**
 * This CustomParametersView subclass extends the base view
 * by subscribing to updates and triggering 'change:customParameters'
 * every time user changes them.
 * Note there are many places creating similar classes, due to apparent
 * broken logic in the base view. See:
 * - private\ui-legacy\Assets\component\form\view\control\custom-params.es
 * - private\ui-legacy\Assets\campaignui\feature\auto-targets\view\dynamic-target
 * \custom-params-adapter.es
 * This class, hovewer, makes updates propagated
 * as Backbone events instead of Knockout observable changes.
 */
export class CustomParametersRealtimeView extends CustomParametersView {
  initialize(options = {}) {
    super.initialize(options);

    this.viewModel.parameterArray.subscribe((val) => {
      const newVal = _.filter(val, item => !_.isEmpty(item.Key) || !_.isEmpty(item.Value));

      this.trigger('change:customParameters', { isValid: this.isValid(), customParameters: newVal });
    });
  }
}
